<template>
  <div v-if="$userInfo">
    <app-detail-header :show-toggle="true"
      :show-delete="false"
      :show-save="false"
      :show-cancel="false"
      :show-new="false"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column is-narrow">
        <emailsmslog-list-side-menu v-model="filter"
          @filter="filterList"
          @reset="resetList" />
      </div>
      <div class="column">
        <div class="tile is-parent animated">
          <article class="tile is-child box">
            <div class="columns">
              <div class="column is-fullwidth"
                style="overflow: auto; width: 100px">
                <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
                  :columns="columns"
                  :page-index="filter.pageIndex"
                  :page-size="filter.pageSize"
                  :total-rows="totalRows"
                  :is-loading="isTableLoading"
                  :sort-column="filter.sortColumn"
                  :sort-order="filter.sortOrder"
                  @pageChanged="onPageChange"
                  @sort="sort">
                  <tr v-for="(entity, index) in entitySummaries"
                    :key="entity.id"
                    :class="{
                      'is-selected' : selectedRow === index }"
                    @click="highlightSelected(index, $event)">
                    <td
                      :class="{
                        'has-text-primary' : selectedRow !== index && entity.assetType === 'EMAIL',
                        'has-text-danger' : selectedRow !== index && entity.assetType === 'SMS',
                        'has-text-dark' : selectedRow === index }">
                      {{ entity.assetType }}</td>
                    <td>
                      <span style="display: flex; align-items: center;">
                        <span class="icon is-small mr-1">
                          <i :class="entity.direction === 'Incoming' ? 'mdi mdi-call-received' : 'mdi mdi-call-made'" />
                        </span>
                        <span>{{ entity.direction }}</span>
                      </span>
                    </td>
                    <td>{{ entity.status }}</td>
                    <td class="col-width">
                      <div>{{ $filters.formatDateTimeLocale(entity.sentOn, $userInfo.locale) }}</div>
                    </td>
                    <td>{{ entity.contact }}</td>
                    <td>
                      <router-link :to="{ path: `/quotes/${entity.quoteId}` }">
                        {{ entity.quoteNoRef }}
                      </router-link>
                    </td>
                    <td>{{ entity.claimNo }}</td>
                    <td>{{ entity.rego }}</td>
                    <!-- <td class="is-email">
                      <div>{{ entity.sendTo }}</div>
                    </td> -->
                    <!-- <td class="is-email col-width">
                      <div>{{ entity.cc }}</div>
                    </td> -->
                    <td class="col-message">
                      <div>
                        <a @click.prevent="edit(entity.id, $event)"
                          :href="generateUrl(entity.id)">
                          <span v-html="entity.messageHtml"></span>
                          <!-- {{ $filters.replaceBr(entity.message) }} -->
                        </a>
                      </div>
                    </td>
                    <!-- <td class="has-text-centered">
                      <a class="button is-primary is-small is-inverted tooltip is-tooltip-left"
                        @click.prevent="edit(entity.id, $event)"
                        :href="generateUrl(entity.id)"
                        data-tooltip="Click to view">
                        <span class="icon is-medium">
                          <i class="mdi mdi-file-eye mdi-24px" />
                        </span>
                      </a>
                    </td> -->
                  </tr>
                  <template slot="empty">
                    <section class="section">
                      <div class="content has-text-grey has-text-centered">
                        <span icon="icon is-large">
                          <i class="mdi mdi-48px mdi-emoticon-sad" />
                        </span>
                        <p>Nothing</p>
                      </div>
                    </section>
                  </template>
                </bulma-table>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppDetailHeader from '@/components/AppDetailHeader'
import EmailSmsLogListSideMenu from './EmailSmsLogListSideMenu'
import EmailSmsLogService from './EmailSmsLogService'
import { DateTimeFiltersMixin } from '@/components/mixins/filters'
import { AppHeaderButtonTypes } from '@/enums'
import StoreMixin from './storeMixin'
import EmailSmsLogValidation from './EmailSmsLogValidation'
import BulmaTable from '@/components/BulmaTable'
import { Columns } from './columns'
import PrintPreviewRoutes from '@/components/printpreview/route-types'
import { Emailer } from '@/classes'
import _transform from 'lodash/transform'
import { KeyValuePairModel } from '@/classes/viewmodels'

export default {
  name: 'EmailsmslogListView',
  components: {
    AppDetailHeader,
    [EmailSmsLogListSideMenu.name]: EmailSmsLogListSideMenu,
    BulmaTable
  },
  mixins: [DateTimeFiltersMixin, EmailSmsLogValidation, StoreMixin],
  data() {
    return {
      entitySummaries: {},
      totalRows: 0,
      filter: {
        dateFrom: '',
        dateTo: '',
        type: '',
        status: '',
        sortColumn: Columns[3].name,
        sortOrder: Columns[3].defaultOrder,
        pageIndex: 1,
        pageSize: 18,
        quoteNo: '',
        rego: '',
        claimNo: '',
        direction: ''
      },
      selectedRow: null,
      isTableLoading: false
    }
  },
  computed: {
    filterKey() {
      if (this.$userInfo) {
        return `${this.$userInfo.sessionId}|${this.$route.meta.fkey}`
      } else {
        return ''
      }
    },
    columns() {
      return Columns
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$v.filter.$touch()
  },
  methods: {
    highlightSelected(index, event) {
      this.selectedRow = index
    },
    generateUrl(id) {
      return `emailsmslogs/${id}`
    },
    edit(id, event) {
      this.$router.push({
        name: 'EmailSmsLogDetail',
        params: { id: id }
      })
    },
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.AddNew:
          this.addNew()
          break
        case AppHeaderButtonTypes.Print:
          this.print1()
          break
        case AppHeaderButtonTypes.Delete:
          break
        case AppHeaderButtonTypes.Save:
          break
        case AppHeaderButtonTypes.Cancel:
          break
      }
    },
    filterList() {
      if (this.$v.filter.$error) {
        this.$notification.openNotificationWithType('danger', 'Email/SMS Log', 'Filter validation errors.')
        return false
      }
      this.filter.pageIndex = 1
      this.persistFilter()
      this.getData()
    },
    sort(name, order) {
      this.filter.sortColumn = name
      this.filter.sortOrder = order
      this.persistFilter()
      this.getData()
    },
    resetList() {
      this.filter.dateFrom = ''
      this.filter.dateTo = ''
      this.filter.type = ''
      this.filter.status = ''
      this.filter.sortColumn = Columns[3].name
      this.filter.sortOrder = Columns[3].defaultOrder
      this.filter.pageIndex = 1
      this.filter.pageSize = 18
      this.filter.quoteNo = ''
      this.filter.rego = ''
      this.filter.claimNo = ''
      this.filter.direction = ''
      this.persistFilter()
      this.getData()
    },
    persistFilter() {
      sessionStorage.setItem(this.filterKey, JSON.stringify(this.filter))
    },
    retrieveFilter() {
      const filter = JSON.parse(sessionStorage.getItem(this.filterKey))
      if (filter) {
        this.filter = filter
      }
    },
    onPageChange(pageIndex) {
      this.filter.pageIndex = pageIndex
      this.persistFilter()
      this.getData()
    },
    async getData() {
      // this.$showSpinner()
      this.isTableLoading = true
      this.retrieveFilter()
      this.entitySummaries = await EmailSmsLogService.getEntitySummaries(this.filter)
      this.totalRows = this.entitySummaries.length > 0 ? this.entitySummaries[0].totalRows : 0
      this.isTableLoading = false
      // this.$hideSpinner()
    },
    print() {
      const params = Object.assign(
        {
          reportname: this.$route.meta.report,
          companyId: this.$userInfo.companyId,
          timezoneoffset: this.$filters.getSiteTimezoneOffset()
        },
        this.filter
      )
      params.pageIndex = 1
      params.pageSize = this.totalRows
      const paramsFlat = Object.keys(params)
        .map((e) => `${e.toLowerCase()}=${params[e]}`)
        .join('&')
        .replace('&sortorder', '&sortdirection')
        .replace('&datefrom', '&createdfrom')
        .replace('&dateto', '&createdto')
      const url = `${this.$route.meta.reportUrl}?${paramsFlat}`
      window.open(url, '_blank')
    },
    print1() {
      let params = Object.assign(
        {
          companyId: this.$userInfo.companyId,
          timezoneoffset: this.$filters.getSiteTimezoneOffset()
        },
        this.filter
      )
      params.pageIndex = 1
      params.pageSize = this.totalRows
      // const query = this.$lzstring.compressToEncodedURIComponent(
      //   Object.keys(params)
      //     .map(e => `${e.toLowerCase()}=${params[e]}`)
      //     .join('&')
      //     .replace('&sortorder', '&sortdirection')
      //     .replace('&datefrom', '&createdfrom')
      //     .replace('&dateto', '&createdto')
      // )
      params = _transform(params, function (result, value, key) {
        if (key.toLowerCase() === 'sortorder') {
          result['sortdirection'] = value
        } else if (key.toLowerCase() === 'datefrom') {
          result['createdfrom'] = value
        } else if (key.toLowerCase() === 'dateto') {
          result['createdto'] = value
        } else {
          result[key.toLowerCase()] = value
        }
      })
      const keyValuePairs = KeyValuePairModel.convertToKeyValuePairs(params)
      this.addReportParameters(keyValuePairs)

      const emailer = new Emailer()
      emailer.subject = 'Email/SMS Log Listing'
      emailer.reportName = 'EmailSmsLogList'
      this.addEmailer(emailer)
      this.$router.push({
        name: PrintPreviewRoutes.PrintPreview.name,
        params: { reportName: this.$route.meta.report },
        query: { parameterId: this.$guid.newGuid(), emailerId: emailer.id }
      })
    },
    async addNew() {
      this.addStoreItem()
    }
  }
}
</script>
<style lang="scss" scoped>
.col-message {
  max-width: 500px;
  div {
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.col-width {
  div {
    width: 160px;
  }
}
</style>
